module.exports = __webpack_public_path__ + "img/006-jupiter.7b0ea242.svg";